export default function getResource(label, vars = []) {
    const resources = {
        freeReturnsMessage: 'Free 30-day returns online or in store',
        freeReturnsAriaLabel: 'Free 30-day returns online or in store. Opens returns policy details.'
    };

    return resources[label];
}
